import { grey, Icon } from '@pelotoncycle/design-system'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type CopyToClipboardButtonProps = {
  value: string
  label?: string
}

export const CopyToClipboardButton: React.FC<CopyToClipboardButtonProps> = ({
  value,
  label,
}) => {
  const { t } = useTranslation()
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    await navigator.clipboard.writeText(value)
    setCopied(true)
    setTimeout(() => setCopied(false), 1200)
  }

  const handleCopyWrapper = () => {
    handleCopy().catch(err => {
      /* eslint-disable-next-line no-console */
      console.error('Fallback clipboard copy failed', err)
    })
  }

  return (
    <CopyButton
      data-testid="copy-to-clipboard"
      type="button"
      onClick={handleCopyWrapper}
      tabIndex={0}
    >
      <StyledIcon
        name="all"
        $copied={copied}
        title={t('copy_to_clipboard.copy_label_to_clipboard', { label })}
      />
      <ConfirmationText data-testid="copied">
        {copied ? t('copy_to_clipboard.copied') : ''}
      </ConfirmationText>
    </CopyButton>
  )
}

const CopyButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
`

const ConfirmationText = styled.span`
  font-size: 12px;
  margin-left: 0.25rem;
  color: ${grey[70]};
`

const StyledIcon = styled(Icon)<{ $copied: boolean }>`
  opacity: ${props => (props.$copied ? 0.5 : 1)};
`
